import { type InputHTMLAttributes, forwardRef } from 'react';

import { classNames } from './classNames';

export type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ className, invalid = false, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={classNames('hotam-field', invalid && 'hotam-field--invalid', className)}
      type={type}
      {...props}
    />
  ),
);

TextField.displayName = 'TextField';
